import { styled } from 'styled-components';
import { Utils } from 'team-hero-ui';

const { flexFn, pxToRem } = Utils;

export const FullWidthWrapper = styled.div`
  > div {
    width: 100%;
    max-width: 100%;
    div {
      max-width: 100%;
    }
  }
`;
export const FullWidthTextInputWrapper = styled.div`
  .MuiTextField-root {
    width: 100%;
    max-width: 100%;
  }
`;

export const HelperTextRow = styled.div`
  height: ${pxToRem(58)};
  padding: ${pxToRem([0, 20])};
  ${flexFn('center', 'center', 'column')};
`;
